import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';

@Component({
  selector: 'app-orders-page',
  templateUrl: './orders-page.component.html',
})
export class OrdersPageComponent implements OnInit {
  @Input() body: any;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'user-order-list',
      this.activatedRoute.snapshot,
    );
    // @todo: retrieve user orders
  }
}
